import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../../src/app/core/models/generic-models';
import { IOtpRequest, IOtpResponse } from '../../../core/models/otp.model';

export const loadForgotPasscodeLoginConfirms = createAction(
  '[ForgotPasscodeLoginConfirm] Load ForgotPasscodeLoginConfirms',
  props<{ request: IOtpRequest }>()
);

export const loadForgotPasscodeLoginConfirmsSuccess = createAction(
  '[ForgotPasscodeLoginConfirm] Load ForgotPasscodeLoginConfirms Success',
  props<{ response: IOtpResponse }>()
);

export const loadForgotPasscodeLoginConfirmsFailure = createAction(
  '[ForgotPasscodeLoginConfirm] Load ForgotPasscodeLoginConfirms Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);


export const newPasscode = createAction(
  '[ForgotPasscodeLoginConfirm] Load NewPasscode',
  props<{ request: IOtpRequest }>()
);

export const newPasscodeSuccess = createAction(
  '[ForgotPasscodeLoginConfirm] Load NewPasscode Success',
  props<{ response: IOtpResponse }>()
);

export const newPasscodeFailure = createAction(
  '[ForgotPasscodeLoginConfirm] Load NewPasscode Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
